import wfhDevicesOnline from './wfhDevicesOnline'
import wfhDwellTimeline from './wfhDwellTimeline'
import wfhInteractionsPerPlaylist from './wfhInteractionsPerPlaylist'
import wfhInteractionsPerProduct, { wfhProductDetails } from './wfhInteractionsPerProduct'
import wfhInteractionsTotal from './wfhInteractionsTotal'
import wfhPlaylistTop from './wfhPlaylistTop'
import wfhSessionsTimeline from './wfhSessionsTimeline'
import wfhStoresTop from './wfhStoresTop'

const wowReducers = [
    wfhDevicesOnline,
    wfhDwellTimeline,
    wfhInteractionsPerPlaylist,
    wfhInteractionsPerProduct,
    wfhProductDetails,
    wfhInteractionsTotal,
    wfhPlaylistTop,
    wfhSessionsTimeline,
    wfhStoresTop,
]

export default wowReducers
